/**
 * 定义好回调函数供框架调用
 * 需要注意，这里是由框架代码来调用的，不要自己直接来调这里的代码
 * 业务使用登录注销时，使用framework/common-control中的login及logout，他们会再调用这里
 */
import {getMenu, getOperation} from '@/app/system-mgt/api/permission'
import {login, logout, getInfo, getCatalogInfo} from '@/app/system-mgt/api/user'
import {getToken} from '@/framework/utils/auth'
import {getUnreadMessageApi, getNotificationProfileApi} from '@/app/system-settings/api/form'

const handler = {
  /**
   * 实际的登录方法，登录页面请调用framework中commonControl的login方法
   * 为了便于处理，必须返回Promise对象
   *
   * @param {JSON} loginData  登录传入的数据，由页面调用时传入，具体格式自行决定
   * @returns {Promise}       实际登录操作的Promise对象
   */
  customLogin: function(loginData) {
    return login(loginData).then(result => {
      return result
    }).catch(error => {
      // reject(error);
      console.log("excute customLogin error");
      console.log(error);
      console.log("excute customLogin error");
    })
  },

  /**
   * 登录后数据初始化的方法
   * 为了便于处理，必须返回Promise对象
   *
   * @returns {Promise}       获取初始化数据
   */
  getInitData: function() {
    return Promise.all([getInfo(getToken()), getMenu(), getOperation()]).then(values => {
      return {
        user: values[0],
        menus: values[1],
        operations: values[2]
      }
    })
  },

  /**
   * 注销时触发，可自定义注销时要实现的逻辑
   *
   * @returns {Promise}       操作的Promise对象
   */
  customLogout: function(data) {
    return logout(data).then(result => {
      return result
    }).catch(error => reject(error))
  },

  // 获取用户未读信息
  getUnreadMessage: function(userId) {
    return getUnreadMessageApi(userId).then((res) => {
      if (res.error_code === '100') {
        return res.response_body.count
      }
    }).catch(error => reject(error))
  },

  // 获取条目信息
  getCatalogInfo: function(json) {
    return getCatalogInfo(json).then((res) => {
      if (res.error_code === '100') {
        localStorage.setItem('catalogId', res.response_body.content[0].catalogId) // 设置条目信息
      }
    }).catch(error => reject(error))
  },

  // 获取用户通知概要信息
  getNotificationProfile: function(userId, data) {
    return getNotificationProfileApi(userId, data).then((res) => {
      if (res.error_code === '100') {
        return res.response_body
      }
    }).catch(error => reject(error))
  }
}

export default handler
